import { apiFetch } from "@/api/client";
import { ENDPOINTS } from "@/api/endpoints";
import type {
  Client,
  CreateClientPayload,
  UpdateClientPayload,
  PageResponse,
  AuditEntry,
  ClientPageQuery,
} from "./types";

export function listClients(
  limit = 50,
  offset = 0,
): Promise<PageResponse<Client>> {
  return apiFetch(`${ENDPOINTS.clients.list}?limit=${limit}&offset=${offset}`);
}

export function listClientPage(
  query: ClientPageQuery,
  signal?: AbortSignal,
): Promise<PageResponse<Client>> {
  const params = new URLSearchParams({
    limit: String(query.limit),
    offset: String(query.offset),
  });
  const search = query.search.trim();
  if (search) params.set("search", search);

  return apiFetch(`${ENDPOINTS.clients.list}?${params}`, { signal });
}

export function createClient(payload: CreateClientPayload): Promise<Client> {
  return apiFetch(ENDPOINTS.clients.list, {
    method: "POST",
    body: JSON.stringify(payload),
  });
}

export function updateClient(
  id: string,
  payload: UpdateClientPayload,
): Promise<Client> {
  return apiFetch(ENDPOINTS.clients.detail(id), {
    method: "PATCH",
    body: JSON.stringify(payload),
  });
}

export function deleteClient(id: string): Promise<void> {
  return apiFetch(ENDPOINTS.clients.detail(id), { method: "DELETE" });
}

export function getClientAuditLog(
  id: string,
  limit = 50,
  offset = 0,
): Promise<PageResponse<AuditEntry>> {
  return apiFetch(
    `${ENDPOINTS.clients.detail(id)}/audit?limit=${limit}&offset=${offset}`,
  );
}
